export default __webpack_public_path__ + "static/media/sticker-q.f665b546.png";